module.exports = __webpack_public_path__ + "static/media/wedding.1b3968f2.jpg";